import { render, staticRenderFns } from "./qSelectItem.vue?vue&type=template&id=d5462512&scoped=true&"
import script from "./qSelectItem.vue?vue&type=script&lang=ts&"
export * from "./qSelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./qSelectItem.vue?vue&type=style&index=0&id=d5462512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5462512",
  null
  
)

export default component.exports